import React from "react";
import { ListTable, Stack } from "sprint-common-web";

import { OrderRequestSectionWrapper } from "../components/OrderRequestSectionWrapper";
import { createOrderRequestAssetsSectionColumns } from "./createOrderRequestAssetsSectionColumns";
import { getOrderRequestAssetsItems } from "./OrderRequestAssetItem";

type OrderRequestAssetsSectionProps = {
    minHeight: number;
};

export const OrderRequestAssetsSection = ({ minHeight }: OrderRequestAssetsSectionProps): JSX.Element => {
    return (
        <OrderRequestSectionWrapper
            header="Assets"
            style={{ minHeight, flex: 1, width: "inherit" }}
            testId={"order-request-assets-section"}
        >
            {(orderRequest, additionalProps) => (
                <Stack style={{ overflowY: "auto", minHeight: 250 }}>
                    <ListTable
                        columns={createOrderRequestAssetsSectionColumns({
                            areNotesLoading: additionalProps?.areNotesLoading
                        })}
                        testId="order-request-assets-list"
                        isLoading={false}
                        items={getOrderRequestAssetsItems(orderRequest)}
                        shimmerLines={1}
                        noItemsMessage="No assets"
                        layoutMode="justified"
                    />
                </Stack>
            )}
        </OrderRequestSectionWrapper>
    );
};
